import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map, tap } from 'rxjs/operators';

import { assertNotNull } from '@core/prelude';
import { ClaimsService } from '@core/authentication/claims.service';
import { Claims } from '@core/authentication/claims';
import { EntityType } from '@features/contacts/models';
import { ContactEventService } from '@features/contacts/services/contact-event.service';
import { SidebarSubMenuItem } from '@shared/components/menu/sidebar-sub-menu/sub-menu.model';

@Component({
  selector: 'spark-contacts-individual-layout',
  templateUrl: './individual-layout.component.html',
  styleUrls: ['./individual-layout.component.scss']
})
export class IndividualLayoutComponent implements OnInit, OnDestroy {
  routePrefix = ['/Contacts', 'Individual'];
  items: SidebarSubMenuItem[][] = [];

  individualId$ = this.route.paramMap.pipe(
    map((params) => params.get('individualId')),
    tap((x) => this.contactEventService.updateContactId(EntityType.Individual, x)),
    tap((x) => {
      this.contactEventService.updateContactId(EntityType.Individual, x);
      if (x) {
        this.routePrefix = ['/Contacts', 'Individual', x];
      }
    }),
    assertNotNull(
      'Internal error: <app-individual-layout> expects individualId parameter in route'
    )
  );
  
  // Use resolved data from route resolver
  individualSummary$ = this.route.data.pipe(
    map(data => data['individual'])
  );

  constructor(
    private route: ActivatedRoute,
    private contactEventService: ContactEventService,
    private claimsService: ClaimsService
  ) {}

  ngOnInit(): void {
    this.setupMenuItems();
  }

  ngOnDestroy() {
    this.contactEventService.updateContactId(EntityType.Individual, null);
    this.contactEventService.resetContactInfo();
  }

  private setupMenuItems(): void {
    const baseMenuItems: SidebarSubMenuItem[] = [
      {
        label: 'Summary',
        link: []
      },
      {
        label: 'Notes',
        link: ['Notes']
      },
      {
        label: 'Opportunities',
        link: ['Opportunities']
      },
      {
        label: 'Products',
        link: ['Products']
      },
      {
        label: 'Tasks',
        link: ['Tasks']
      }
    ];

    // Only show Audit menu item for Network Administrators
    if (this.claimsService.userRole === Claims.UserRoles.NetworkAdministrator) {
      baseMenuItems.push({
        label: 'Audit',
        link: ['Audit']
      });
    }

    this.items = [baseMenuItems];
  }
}
